import { createAuthClient } from "better-auth/react";

const baseURL = import.meta.env.VITE_API_URL;
if (!baseURL) {
  throw new Error("VITE_API_URL is not set");
}

export const authClient = createAuthClient({ baseURL });

// Re-export React-friendly bindings. Other actions (signIn.email, signUp.email,
// signOut, forgetPassword, etc.) are accessed via authClient.<method> directly.
export const { useSession, getSession, signOut } = authClient;
